import React,{useEffect} from 'react'
import styled from 'styled-components'
import AOS from 'aos';
import 'aos/dist/aos.css';

const Services = () => {
  useEffect(()=>{
    AOS.init();
  },[])
  return (
    <>
      <Wrapper>
        <div className="container">
          <div className="services">
            <div className="services_heading">
                <h1>Services</h1>
            </div>
            <div className="skills">
                <div className="box" data-aos="flip-left"  data-aos-duration="800">
                   <div className="image">
                    <img src="./Images/service1.png" alt="" width={30}/>
                   </div>
                   <div className="heading">
                    <h3> Front-end Development (React.js) </h3>
                   </div>
                   <div className="details">
                    <p>Transforms design concepts into functional and responsive website elements.</p>
                   </div>
                </div>

                <div className="box"  data-aos="flip-left"  data-aos-duration="800">
                   <div className="image">
                    <img src="./Images/services2.png" alt="" width={30}/>
                   </div>
                   <div className="heading">
                    <h3>Website Designing </h3>
                   </div>
                   <div className="details">
                    <p>it's about creating a visually appealing and easy-to-use online space that grabs attention and provides information.</p>
                   </div>
                </div>

                <div className="box"  data-aos="flip-left"  data-aos-duration="800">
                   <div className="image">
                    <img src="./Images/services3.png" alt="" width={30}/>
                   </div>
                   <div className="heading">
                    <h3> Mobile App Designing </h3>
                   </div>
                   <div className="details">
                    <p>Creating user-friendly and visually appealing applications for smartphones, making everyday tasks convenient and enjoyable.</p>
                   </div>
                </div>

                <div className="box"  data-aos="flip-left"  data-aos-duration="800">
                   <div className="image">
                    <img src="./Images/services4.png" alt="" width={30}/>
                   </div>
                   <div className="heading">
                    <h3> Landing Page Designing </h3>
                   </div>
                   <div className="details">
                    <p>Creating a focused, persuasive web page that encourages visitors to take a specific action, such as signing up or making a purchase.</p>
                   </div>
                </div>

                <div className="box"  data-aos="flip-left"  data-aos-duration="800">
                   <div className="image">
                    <img src="./Images/services5.png" alt="" width={30}/>
                   </div>
                   <div className="heading">
                    <h3> Dashboard Designing </h3>
                   </div>
                   <div className="details">
                    <p>Crafting a visual, user-friendly interface that displays essential data and information in a clear and organized way. </p>
                   </div>
                </div>

                <div className="box"  data-aos="flip-left"  data-aos-duration="800">
                   <div className="image">
                    <img src="./Images/services6.png" alt="" width={30}/>
                   </div>
                   <div className="heading">
                    <h3> Basic SEO </h3>
                   </div>
                   <div className="details">
                    <p>SEO is the practice of optimizing a website to improve its visibility on search engines like Google.</p>
                   </div>
                </div>


                
               
            </div>
           
          </div>
        </div>
        <div className="line"></div>
      </Wrapper>
    </>
  )
}

export default Services

const Wrapper = styled.section`

.container{
    width: 100%;
    height: auto;
    background-color: rgba(45, 46, 46, 1);
    padding-left: 5%;
    padding-right: 5%;
}
.services_heading h1{
    font-size: 35px;
    text-align: center;
    color: rgba(255, 204, 0, 1);
    padding-top: 50px;
}
.skills{
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    padding-top: 20px;
    padding-bottom: 50px;
}
.box{
    width: 32%;
    height: 260px;
    background-color: rgba(33, 34, 34, 1);
    margin-top: 20px;
    border-radius: 10px;
    padding-left: 20px;
    padding-right: 2%;
    padding-top: 3%;
   padding-bottom: 20px;
}
.heading h3{
  padding: 10px 0;
  color: rgba(255, 204, 0, 1);
}
.line{
  width: 100%;
  height: 1px;
  background-color:  rgba(67, 67, 67, 1);
}
@media (max-width: 1110px) {
  .box{
    height: 360px;
  }
}

@media (max-width: 768px) {
  .skills{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  
}
.box{
  width: 48%;
  height: 260px;
}
.container{
  padding-left: 3%;
  padding-right: 3%;
}
.services_heading h1{
  font-size: 25px;
}
.details p{
  font-size: 16px;
}
}
@media (max-width: 576px) {
  .box{
  width: 100%;
  height: 230px;
}
.container{
  padding-left: 5%;
  padding-right: 5%;
}
}
`
